/**
 * Restaurant Dashboard design tokens.
 *
 * One brand accent (the red in the RushMyFood logo) for the current period and
 * primary actions; gray for the comparison period; green and red ONLY for
 * positive and negative change. The same values are exposed as CSS custom
 * properties (cssVars) on the page root, and as plain hex here because
 * Chart.js draws on a canvas and cannot read CSS variables.
 *
 * Text needs 4.5:1 on white; graphics need 3:1. So the success/danger tokens
 * colour chips and marks, while chip TEXT uses one step darker (`upText`,
 * `downText`) — #16A34A on its 10% tint is only 3.1:1. `muted` (#9CA3AF) is
 * for lines and icons, never body text; readable secondary text is `textMuted`.
 */
export const C = {
  page: '#F6F7F9',
  card: '#FFFFFF',
  border: '#E8EAEE',
  borderStrong: '#CDD2D9',
  text: '#111827',
  textMuted: '#6B7280',
  textFaint: '#9CA3AF',
  brand: '#ED1D26',
  brandText: '#C8101A',
  brandSoft: 'rgba(237,29,38,0.10)',
  brandFill: 'rgba(237,29,38,0.08)',
  muted: '#9CA3AF',
  prev: '#9CA3AF',
  prevBar: '#E5E7EB',
  grid: '#EEF0F3',
  success: '#16A34A',
  danger: '#DC2626',
  up: '#16A34A',
  upSoft: 'rgba(22,163,74,0.10)',
  upText: '#15803D',
  down: '#DC2626',
  downSoft: 'rgba(220,38,38,0.10)',
  downText: '#B91C1C',
  amber: '#F59E0B',
  amberSoft: 'rgba(245,158,11,0.12)',
  amberText: '#92400E',
  sky: '#0EA5E9',
  skySoft: 'rgba(14,165,233,0.10)',
  skyText: '#0369A1',
  open: '#16A34A',
  closed: '#9CA3AF'
}

/* Categorical palette for channels / fulfillment / payment, in this order. */
export const SERIES = ['#ED1D26', '#F59E0B', '#0EA5E9', '#6B7280', '#10B981']

export const cssVars = {
  '--brand': C.brand,
  '--brand-soft': C.brandSoft,
  '--muted': C.muted,
  '--success': C.success,
  '--danger': C.danger,
  '--page': C.page,
  '--border': C.border
}

export const RADIUS = '12px'

export const FONT = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

/** Card surface: flat, 1px border that darkens a touch on hover. No big shadows. */
export const cardSx = {
  bgcolor: C.card,
  border: `1px solid ${C.border}`,
  borderRadius: RADIUS,
  boxShadow: 'none',
  transition: 'border-color 160ms ease',
  '&:hover': { borderColor: C.borderStrong }
}

export const tabular = { fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum"' }
